/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSupplierDto
 */
export interface UpdateSupplierDto {
    /**
     * Supplier first name
     * @type {string}
     * @memberof UpdateSupplierDto
     */
    firstName?: string;
    /**
     * Supplier last name
     * @type {string}
     * @memberof UpdateSupplierDto
     */
    lastName?: string;
    /**
     * Supplier email address
     * @type {string}
     * @memberof UpdateSupplierDto
     */
    email?: string;
    /**
     * Supplier phone number
     * @type {string}
     * @memberof UpdateSupplierDto
     */
    phoneNumber?: string;
    /**
     * New password (will be hashed)
     * @type {string}
     * @memberof UpdateSupplierDto
     */
    password?: string;
    /**
     * Updated supplier roles array
     * @type {Array<string>}
     * @memberof UpdateSupplierDto
     */
    roles?: Array<UpdateSupplierDtoRolesEnum>;
    /**
     * Approve/reject supplier account - set to true to approve, false to reject
     * @type {boolean}
     * @memberof UpdateSupplierDto
     */
    isConfirmed?: boolean;
    /**
     * Organization ID that supplier belongs to
     * @type {number}
     * @memberof UpdateSupplierDto
     */
    organizationId?: number;
}


/**
 * @export
 */
export const UpdateSupplierDtoRolesEnum = {
    GlobalSupplierAdmin: 'GLOBAL_SUPPLIER_ADMIN',
    PromotionSupplierAdmin: 'PROMOTION_SUPPLIER_ADMIN',
    CatalogSupplierAdmin: 'CATALOG_SUPPLIER_ADMIN',
    OrderSupplierAdmin: 'ORDER_SUPPLIER_ADMIN',
    AddProductSupplierAdmin: 'ADD_PRODUCT_SUPPLIER_ADMIN',
    ReadOnlySupplierAdmin: 'READ_ONLY_SUPPLIER_ADMIN'
} as const;
export type UpdateSupplierDtoRolesEnum = typeof UpdateSupplierDtoRolesEnum[keyof typeof UpdateSupplierDtoRolesEnum];


/**
 * Check if a given object implements the UpdateSupplierDto interface.
 */
export function instanceOfUpdateSupplierDto(value: object): value is UpdateSupplierDto {
    return true;
}

export function UpdateSupplierDtoFromJSON(json: any): UpdateSupplierDto {
    return UpdateSupplierDtoFromJSONTyped(json, false);
}

export function UpdateSupplierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSupplierDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'password': json['password'] == null ? undefined : json['password'],
        'roles': json['roles'] == null ? undefined : json['roles'],
        'isConfirmed': json['isConfirmed'] == null ? undefined : json['isConfirmed'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
    };
}

export function UpdateSupplierDtoToJSON(value?: UpdateSupplierDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'password': value['password'],
        'roles': value['roles'],
        'isConfirmed': value['isConfirmed'],
        'organizationId': value['organizationId'],
    };
}

